module.exports = __webpack_public_path__ + "img/color.e7ab8d10.png";